import Storage from '@aws-amplify/storage';
import { faFolderOpen, faFolderUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import {
  Tooltip,
  OverlayTrigger,
  Button,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';

Storage.configure({
  AWSS3: {
    bucket: 'labsmarts-next',
    region: 'us-east-1',
  },
});

export const Upload = ({
  setState,
  clearForm,
  showModal,
  isUploadAvailable,
}) => {
  const inputFile = useRef(null);

  const [lab, setLab] = useState('Labcorp');
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);

  const openUploadPDFInfoWindow = () => {
    window.open('https://labsmarts.com/upload_test_results');
  };

  //openUploadPDFInfoWindow = () => {
  //  window.open('https://labsmarts.com/upload_test_results');
  //}

  const handleUpload = async e => {
    const newFile = e.target.files[0];

    if (!newFile) return;

    const name = newFile.name?.replaceAll(' ', '_');

    if (!newFile) return;

    setLoading(true);
    setFile(newFile?.name);

    try {
      console.log('Uploading file: ', await Storage.put(name, newFile));

      const res = await fetch(
        process.env.REACT_APP_ENV === 'prod'
          ? 'https://fr3g7xel6oznoyhlvtu2ohqr6u0cbwao.lambda-url.us-east-1.on.aws/'
          : 'https://b6oxxdcpa6zsxddhvnqa7f55zy0kushi.lambda-url.us-east-1.on.aws/',
        { method: 'POST', body: JSON.stringify({ lab, name }) },
      );
      const {
        fileName,
        results,
        fields: { collectionDate },
      } = await res.json();

      if (inputFile.current.value?.replaceAll(' ', '_')?.endsWith(fileName)) {
        setLoading(false);
        setState({
          ...results,
          collectionDate: moment(collectionDate).startOf('day').toISOString(),
          collectionDateForUI: moment(collectionDate).toDate(),
        });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    clearForm();
    setFile(null);
    setLoading(false);
    inputFile.current.value = null;
  };

  const panelTooltip = (
    <Tooltip id="modal-tooltip">
      Click this icon to learn more about the labs we support.
    </Tooltip>
  );

  return (
    <>
      {/* <Form.Group as={Row} key="lab-group" controlId="lab-group">
        <Form.Label column sm>
          Lab
        </Form.Label>
        <Col sm>
          <DropdownButton id="dropdown-basic-button" title={lab}>
            <Dropdown.Item onClick={() => setLab('Labcorp')}>
              Labcorp
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setLab('Labcorp Old')}>
              Labcorp Old
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setLab('Quest')}>Quest</Dropdown.Item>
          </DropdownButton>
        </Col>
        <Col sm></Col>
      </Form.Group> */}
      <Form.Group
        as={Row}
        key="upload-group"
        controlId="upload-group"
        className="d-flex align-items-center"
      >
        <Form.Label column sm={4}>
          Upload Test Results&nbsp;
          <OverlayTrigger overlay={panelTooltip}>
            <FontAwesomeIcon
              className="external-link"
              icon="external-link-alt"
              onClick={openUploadPDFInfoWindow}
            />
          </OverlayTrigger>
        </Form.Label>
        <Col className="d-flex">
          <Button
            variant="primary"
            disabled={loading}
            className="d-flex align-items-center"
            onClick={() =>
              isUploadAvailable ? inputFile.current.click() : showModal()
            }
          >
            <FontAwesomeIcon
              icon={file ? faFolderUpload : faFolderOpen}
              className="mr-3"
            />
            Browse
            <Spinner
              className="ml-3"
              animation="border"
              size="sm"
              hidden={!loading}
            />
          </Button>
          <input
            hidden
            type="file"
            ref={inputFile}
            onChange={handleUpload}
            className="form-control-file"
          />
          {file && (
            <b className="ml-4">
              {file}{' '}
              <Button variant="link" onClick={handleCancel}>
                {loading ? 'Cancel' : 'Clear'}
              </Button>
            </b>
          )}
        </Col>
      </Form.Group>
    </>
  );
};
